import React, {Component} from "react";
import { Tooltip } from "reactstrap";

class TooltipItem extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            tooltipOpen: false
        };
    }

    toggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    render() {
        return (
            <span>
            <Tooltip placement={this.props.placement} isOpen={this.state.tooltipOpen}
                     target={this.props.target} toggle={this.toggle}>
                {this.props.tooltipText}
            </Tooltip>
                </span>
        );
    }
}

export default TooltipItem;